import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
import '@polymer/polymer/lib/elements/dom-module.js';
import { OverlayElement } from '@vaadin/vaadin-overlay/src/vaadin-overlay.js';
var $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = "<dom-module id=\"vaadin-select-overlay-styles\" theme-for=\"vaadin-select-overlay\">\n  <template>\n    <style>\n      :host {\n        align-items: flex-start;\n        justify-content: flex-start;\n      }\n    </style>\n  </template>\n</dom-module>";
document.head.appendChild($_documentContainer.content);
/**
  * The overlay element.
  *
  * ### Styling
  *
  * See [`<vaadin-overlay>` documentation](https://github.com/vaadin/vaadin-overlay/blob/master/src/vaadin-overlay.html)
  * for `<vaadin-select-overlay>` parts.
  *
  * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
  *
  * @memberof Vaadin
  */

var SelectOverlayElement =
/*#__PURE__*/
function (_OverlayElement) {
  _inherits(SelectOverlayElement, _OverlayElement);

  function SelectOverlayElement() {
    _classCallCheck(this, SelectOverlayElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectOverlayElement).apply(this, arguments));
  }

  _createClass(SelectOverlayElement, null, [{
    key: "is",
    get: function get() {
      return 'vaadin-select-overlay';
    }
  }]);

  return SelectOverlayElement;
}(OverlayElement);

customElements.define(SelectOverlayElement.is, SelectOverlayElement);